import { defer, type LoaderFunctionArgs } from "react-router-dom";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { getDetailInfo } from "./common/services";

export function limitDetailsLoader({ request }: LoaderFunctionArgs) {
  const type = new URL(request.url).searchParams.get("type") || "";
  return defer({
    coreData: resolveLoaderResult(getDetailInfo({ type })),
  });
}
